import CardLabels from "./CardLabels";
export default CardLabels;
